var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as go from '../../../../libs/gojs/release/go';
import * as _ from 'lodash';
import { ElementSizeHelper } from './element-size-helper';
import { Size } from '../utils/common/size';
import { ColumnResizingTool } from './ColumnResizingTool';
import { RowResizingTool } from './RowResizingTool';
import { DiagramConsts } from '../diagram-consts';
var DesignerCommandHandler = /** @class */ (function (_super) {
    __extends(DesignerCommandHandler, _super);
    function DesignerCommandHandler(layerService) {
        var _this = _super.call(this) || this;
        _this.layerService = layerService;
        _this._arrowKeyBehavior = 'move';
        _this._pasteOffset = new go.Point(10, 10);
        _this._lastPasteOffset = new go.Point(0, 0);
        return _this;
    }
    // region common
    /**
     * 设置diagram属性值
     * @this {DrawCommandHandler}
     */
    DesignerCommandHandler.prototype.setDataProperty = function (dataArray, type, value) {
        this.diagram.model.setDataProperty(dataArray, type, value);
    };
    // endregion
    // region align
    /**
     * This controls whether or not the user can invoke the {@link #alignLeft}, {@link #alignRight},
     * {@link #alignTop}, {@link #alignBottom}, {@link #alignCenterX}, {@link #alignCenterY} commands.
     * @this {DrawCommandHandler}
     * @return {boolean}
     * This returns true:
     * if the diagram is not {@link Diagram#isReadOnly},
     * if the model is not {@link Model#isReadOnly}, and
     * if there are at least two selected {@link Part}s.
     */
    DesignerCommandHandler.prototype.canAlignSelection = function () {
        var diagram = this.diagram;
        if (diagram == null || diagram.isReadOnly || diagram.isModelReadOnly) {
            return false;
        }
        if (diagram.selection.count < 2) {
            return false;
        }
        return true;
    };
    /**
     * Aligns selected parts along the left-most edge of the left-most part.
     * @this {DrawCommandHandler}
     */
    DesignerCommandHandler.prototype.alignLeft = function () {
        var _this = this;
        var diagram = this.diagram;
        diagram.startTransaction('aligning left');
        var minPosition = Infinity;
        diagram.selection.each(function (current) {
            if (_this.cannotAlign(current)) {
                return;
            }
            minPosition = Math.min(current.position.x, minPosition);
        });
        diagram.selection.each(function (current) {
            if (_this.cannotAlign(current)) {
                return;
            }
            current.move(new go.Point(minPosition, current.position.y));
        });
        diagram.commitTransaction('aligning left');
    };
    /**
     * Aligns selected parts at the right-most edge of the right-most part.
     * @this {DrawCommandHandler}
     */
    DesignerCommandHandler.prototype.alignRight = function () {
        var _this = this;
        var diagram = this.diagram;
        diagram.startTransaction('aligning right');
        var maxPosition = -Infinity;
        diagram.selection.each(function (current) {
            if (_this.cannotAlign(current)) {
                return;
            }
            var rightSideLoc = current.actualBounds.x + current.actualBounds.width;
            maxPosition = Math.max(rightSideLoc, maxPosition);
        });
        diagram.selection.each(function (current) {
            if (_this.cannotAlign(current)) {
                return;
            }
            current.move(new go.Point(maxPosition - current.actualBounds.width, current.position.y));
        });
        diagram.commitTransaction('aligning right');
    };
    /**
     * Aligns selected parts at the top-most edge of the top-most part.
     * @this {DrawCommandHandler}
     */
    DesignerCommandHandler.prototype.alignTop = function () {
        var _this = this;
        var diagram = this.diagram;
        diagram.startTransaction('alignTop');
        var minPosition = Infinity;
        diagram.selection.each(function (current) {
            if (_this.cannotAlign(current)) {
                return;
            }
            minPosition = Math.min(current.position.y, minPosition);
        });
        diagram.selection.each(function (current) {
            if (_this.cannotAlign(current)) {
                return;
            }
            current.move(new go.Point(current.position.x, minPosition));
        });
        diagram.commitTransaction('alignTop');
    };
    /**
     * Aligns selected parts at the bottom-most edge of the bottom-most part.
     * @this {DrawCommandHandler}
     */
    DesignerCommandHandler.prototype.alignBottom = function () {
        var _this = this;
        var diagram = this.diagram;
        diagram.startTransaction('aligning bottom');
        var maxPosition = -Infinity;
        diagram.selection.each(function (current) {
            if (_this.cannotAlign(current)) {
                return;
            }
            var bottomSideLoc = current.actualBounds.y + current.actualBounds.height;
            maxPosition = Math.max(bottomSideLoc, maxPosition);
        });
        diagram.selection.each(function (current) {
            if (_this.cannotAlign(current)) {
                return;
            }
            current.move(new go.Point(current.actualBounds.x, maxPosition - current.actualBounds.height));
        });
        diagram.commitTransaction('aligning bottom');
    };
    /**
     * Aligns selected parts at the x-value of the center point of the first selected part.
     * @this {DrawCommandHandler}
     */
    DesignerCommandHandler.prototype.alignCenterX = function () {
        var _this = this;
        var diagram = this.diagram;
        var firstSelection = diagram.selection.first();
        if (!firstSelection) {
            return;
        }
        diagram.startTransaction('aligning Center X');
        var centerX = firstSelection.actualBounds.x + firstSelection.actualBounds.width / 2;
        diagram.selection.each(function (current) {
            if (_this.cannotAlign(current)) {
                return;
            }
            current.move(new go.Point(centerX - current.actualBounds.width / 2, current.actualBounds.y));
        });
        diagram.commitTransaction('aligning Center X');
    };
    /**
     * Aligns selected parts at the y-value of the center point of the first selected part.
     * @this {DrawCommandHandler}
     */
    DesignerCommandHandler.prototype.alignCenterY = function () {
        var _this = this;
        var diagram = this.diagram;
        var firstSelection = diagram.selection.first();
        if (!firstSelection) {
            return;
        }
        diagram.startTransaction('aligning Center Y');
        var centerY = firstSelection.actualBounds.y + firstSelection.actualBounds.height / 2;
        diagram.selection.each(function (current) {
            if (_this.cannotAlign(current)) {
                return;
            }
            current.move(new go.Point(current.actualBounds.x, centerY - current.actualBounds.height / 2));
        });
        diagram.commitTransaction('aligning Center Y');
    };
    /**
     * Aligns selected parts top-to-bottom in order of the order selected.
     * Distance between parts can be specified. Default distance is 0.
     * @this {DrawCommandHandler}
     */
    DesignerCommandHandler.prototype.alignColumn = function () {
        var _this = this;
        var diagram = this.diagram;
        var sizeHelper = new ElementSizeHelper(this.diagram);
        diagram.startTransaction('align Column');
        var selectedParts = new Array();
        diagram.selection.each(function (current) {
            if (_this.cannotAlign(current)) {
                return;
            }
            selectedParts.push(current);
        });
        if (selectedParts.length <= 2) {
            return;
        }
        // 垂直均布 按 图形的中心点 从 y 轴 从小到大 排个序
        selectedParts.sort(function (a, b) { return a.actualBounds.y + sizeHelper.getHeight(a) / 2 -
            (b.actualBounds.y + sizeHelper.getHeight(b) / 2); });
        var lastPartCenterYPosition = selectedParts[selectedParts.length - 1].actualBounds.y +
            sizeHelper.getHeight(selectedParts[selectedParts.length - 1]) / 2;
        var firstPartCenterYPosition = selectedParts[0].actualBounds.y +
            sizeHelper.getHeight(selectedParts[0]) / 2;
        var adjustLength = (lastPartCenterYPosition - firstPartCenterYPosition) / (selectedParts.length - 1);
        for (var i = 1; i < selectedParts.length - 1; i++) {
            var current = selectedParts[i];
            var currentYPosition = adjustLength * i + firstPartCenterYPosition - sizeHelper.getHeight(current) / 2;
            current.move(new go.Point(current.actualBounds.x, currentYPosition));
        }
        diagram.commitTransaction('align Column');
    };
    /**
     * Aligns selected parts left-to-right in order of the order selected.
     * Distance between parts can be specified. Default distance is 0.
     * @this {DrawCommandHandler}
     */
    DesignerCommandHandler.prototype.alignRow = function () {
        var _this = this;
        var diagram = this.diagram;
        var sizeHelper = new ElementSizeHelper(this.diagram);
        var selectedParts = new Array();
        diagram.selection.each(function (current) {
            if (_this.cannotAlign(current)) {
                return;
            }
            selectedParts.push(current);
        });
        if (selectedParts.length <= 2) {
            return;
        }
        diagram.startTransaction('align Row');
        // 水平均布 按 图形的中心点 从 x 轴 从小到大 排个序
        selectedParts.sort(function (a, b) { return a.actualBounds.x + sizeHelper.getWidth(a) / 2
            - (b.actualBounds.x + sizeHelper.getWidth(b) / 2); });
        var lastPartCenterXPosition = selectedParts[selectedParts.length - 1].actualBounds.x +
            sizeHelper.getWidth(selectedParts[selectedParts.length - 1]) / 2;
        var firstPartCenterXPosition = selectedParts[0].actualBounds.x +
            sizeHelper.getWidth(selectedParts[0]) / 2;
        var adjustLength = (lastPartCenterXPosition - firstPartCenterXPosition) / (selectedParts.length - 1);
        for (var i = 1; i < selectedParts.length - 1; i++) {
            var current = selectedParts[i];
            var curRightSideLoc = adjustLength * i + firstPartCenterXPosition - sizeHelper.getWidth(current) / 2;
            current.move(new go.Point(curRightSideLoc, current.actualBounds.y));
        }
        diagram.commitTransaction('align Row');
    };
    /**
     * This controls whether or not the part can invoke the align commands.
     * @this {DrawCommandHandler}
     * @return {boolean}
     * This returns true:
     * if the part is not {@link} and not locked{Model#locked}
     */
    DesignerCommandHandler.prototype.cannotAlign = function (current) {
        return (current instanceof go.Group) || (current.data && current.data.locked);
    };
    // endregion
    // region rotate
    /**
     * This controls whether or not the user can invoke the {@link #rotate} command.
     * @this {DrawCommandHandler}
     * @param {number=} angle the positive (clockwise) or
     *  negative (counter-clockwise) change in the rotation angle of each Part, in degrees.
     * @return {boolean}
     * This returns true:
     * if the diagram is not {@link Diagram#isReadOnly},
     * if the model is not {@link Model#isReadOnly}, and
     * if there is at least one selected {@link Part}.
     */
    DesignerCommandHandler.prototype.canRotate = function () {
        var diagram = this.diagram;
        if (diagram == null || diagram.isReadOnly || diagram.isModelReadOnly) {
            return false;
        }
        if (diagram.selection.count < 1) {
            return false;
        }
        return true;
    };
    /**
     * Change the angle of the parts connected with the given part. This is in the command handler
     * so it can be easily accessed for the purpose of creating commands that change the rotation of a part.
     * @this {DrawCommandHandler}
     * @param {number=} angle the positive (clockwise) or negative
     * (counter-clockwise) change in the rotation angle of each Part, in degrees.
     */
    DesignerCommandHandler.prototype.rotate = function (angle) {
        if (angle === undefined) {
            angle = 90;
        }
        var diagram = this.diagram;
        diagram.startTransaction("rotate " + angle.toString());
        diagram.selection.each(function (current) {
            if (current instanceof go.Link || current instanceof go.Group) {
                return;
            } // skips over Links and Groups
            current.angle += angle;
        });
        diagram.commitTransaction("rotate " + angle.toString());
    };
    // endregion rotate
    // region keyboard events
    /**
     * This implements custom behaviors for arrow key keyboard events.
     * Set {@link #arrowKeyBehavior} to "select", "move" (the default), "scroll" (the standard behavior), or "none"
     * to affect the behavior when the user types an arrow key.
     * @this {DrawCommandHandler}*/
    DesignerCommandHandler.prototype.doKeyDown = function () {
        var diagram = this.diagram;
        if (diagram == null) {
            return;
        }
        var e = diagram.lastInput;
        // determines the function of the arrow keys
        if (e.key === 'Up' || e.key === 'Down' || e.key === 'Left' || e.key === 'Right') {
            var behavior = this.arrowKeyBehavior;
            if (behavior === 'none') {
                // no-op
                return;
            }
            else if (behavior === 'select') {
                this._arrowKeySelect();
                return;
            }
            else if (behavior === 'move') {
                this._arrowKeyMove();
                return;
            }
            // otherwise drop through to get the default scrolling behavior
        }
        if (e.key === 'V') {
            return;
        }
        // otherwise still does all standard commands
        _super.prototype.doKeyDown.call(this);
    };
    DesignerCommandHandler.prototype.selectAll = function () {
        _super.prototype.selectAll.call(this);
        var diagram = this.diagram;
        if (diagram == null) {
            return;
        }
        var sel = diagram.selection.copy();
        var lockedParts = [];
        sel.each(function (val) {
            if (val.data && val.data.locked) {
                lockedParts.push(val);
            }
        });
        diagram.selectCollection(sel);
    };
    /**
     * Collects in an Array all of the non-Link Parts currently in the Diagram.
     * @this {DrawCommandHandler}
     * @return {Array}
     */
    // ReSharper disable once InconsistentNaming
    DesignerCommandHandler.prototype._getAllParts = function () {
        var allParts = new Array();
        this.diagram.nodes.each(function (node) {
            allParts.push(node);
        });
        this.diagram.parts.each(function (part) {
            allParts.push(part);
        });
        // note that this ignores Links
        return allParts;
    };
    /**
     * To be called when arrow keys should move the Diagram.selection.
     * @this {DrawCommandHandler}
     */
    // ReSharper disable once InconsistentNaming
    DesignerCommandHandler.prototype._arrowKeyMove = function () {
        var diagram = this.diagram;
        var e = diagram.lastInput;
        // moves all selected parts in the specified direction
        var vdistance = 1;
        var hdistance = 1;
        // if shift is being held down, moves by grid cell size, Else move pixel by pixel.
        if (e.shift && diagram.grid !== null) {
            var cellsize = diagram.grid.gridCellSize;
            hdistance = cellsize.width;
            vdistance = cellsize.height;
        }
        diagram.startTransaction('arrowKeyMove');
        diagram.selection.each(function (part) {
            if (part.data && part.data.locked) {
                return;
            }
            if (e.key === 'Up') {
                part.move(new go.Point(part.actualBounds.x, part.actualBounds.y - vdistance));
            }
            else if (e.key === 'Down') {
                part.move(new go.Point(part.actualBounds.x, part.actualBounds.y + vdistance));
            }
            else if (e.key === 'Left') {
                part.move(new go.Point(part.actualBounds.x - hdistance, part.actualBounds.y));
            }
            else if (e.key === 'Right') {
                part.move(new go.Point(part.actualBounds.x + hdistance, part.actualBounds.y));
            }
        });
        diagram.commitTransaction('arrowKeyMove');
    };
    /**
     * To be called when arrow keys should change selection.
     * @this {DrawCommandHandler}
     */
    // ReSharper disable once InconsistentNaming
    DesignerCommandHandler.prototype._arrowKeySelect = function () {
        var diagram = this.diagram;
        var e = diagram.lastInput;
        // with a part selected, arrow keys change the selection
        // arrow keys + shift selects the additional part in the specified direction
        // arrow keys + control toggles the selection of the additional part
        var nextPart = null;
        if (e.key === 'Up') {
            nextPart = this._findNearestPartTowards(270);
        }
        else if (e.key === 'Down') {
            nextPart = this._findNearestPartTowards(90);
        }
        else if (e.key === 'Left') {
            nextPart = this._findNearestPartTowards(180);
        }
        else if (e.key === 'Right') {
            nextPart = this._findNearestPartTowards(0);
        }
        if (nextPart != null) {
            if (e.shift) {
                nextPart.isSelected = true;
            }
            else if (e.control || e.meta) {
                nextPart.isSelected = !nextPart.isSelected;
            }
            else {
                diagram.select(nextPart);
            }
        }
    };
    /**
     * Finds the nearest Part in the specified direction, based on their center points.
     * if it doesn't find anything, it just returns the current Part.
     * @this {DrawCommandHandler}
     * @param {number} dir the direction, in degrees
     * @return {Part} the closest Part found in the given direction
     */
    // ReSharper disable once InconsistentNaming
    DesignerCommandHandler.prototype._findNearestPartTowards = function (dir) {
        var originalPart = this.diagram.selection.first();
        if (originalPart == null) {
            return null;
        }
        var originalPoint = originalPart.actualBounds.center;
        var allParts = this._getAllParts();
        var closestDistance = Infinity;
        var closest = originalPart; // if no parts meet the criteria, the same part remains selected
        for (var i = 0; i < allParts.length; i++) {
            var nextPart = allParts[i];
            if (nextPart === originalPart) {
                continue;
            } // skips over currently selected part
            var nextPoint = nextPart.actualBounds.center;
            var angle = originalPoint.directionPoint(nextPoint);
            var anglediff = this._angleCloseness(angle, dir);
            if (anglediff <= 45) { // if this part's center is within the desired direction's sector,
                var distance = originalPoint.distanceSquaredPoint(nextPoint);
                distance *= 1 + Math.sin(anglediff * Math.PI / 180);
                // the more different from the intended angle, the further it is
                if (distance < closestDistance) { // and if it's closer than any other part,
                    closestDistance = distance; // remember it as a better choice
                    closest = nextPart;
                }
            }
        }
        return closest;
    };
    /**
     * @this {DrawCommandHandler}
     * @param {number} a
     * @param {number} dir
     * @return {number}
     */
    // ReSharper disable once InconsistentNaming
    DesignerCommandHandler.prototype._angleCloseness = function (a, dir) {
        return Math.min(Math.abs(dir - a), Math.min(Math.abs(dir + 360 - a), Math.abs(dir - 360 - a)));
    };
    /**
     * Reset the last offset for pasting.
     * @override
     * @this {DrawCommandHandler}
     * @param {Iterable.<Part>} coll a collection of {@link Part}s.
     */
    DesignerCommandHandler.prototype.copyToClipboard = function (coll) {
        _super.prototype.copyToClipboard.call(this, coll);
        this._lastPasteOffset.set(this._pasteOffset);
    };
    /**
     * Paste from the clipboard with an offset incremented on each paste, and reset when copied.
     * @override
     * @this {DrawCommandHandler}
     * @return {Set.<Part>} a collection of newly pasted {@link Part}s
     */
    DesignerCommandHandler.prototype.pasteFromClipboard = function () {
        var coll = _super.prototype.pasteFromClipboard.call(this);
        var curobj = this.diagram.findPartAt(this.diagram.lastInput.documentPoint, false);
        this.diagram.select(curobj);
        this.diagram.moveParts(coll, this._lastPasteOffset, true);
        this._lastPasteOffset.add(this._pasteOffset);
        return coll;
    };
    Object.defineProperty(DesignerCommandHandler.prototype, "arrowKeyBehavior", {
        /**
         * Gets or sets the arrow key behavior. Possible values are "move", "select", and "scroll".
         * The default value is "move".
         * @name DrawCommandHandler#arrowKeyBehavior
         * @function.
         * @return {string}
         */
        get: function () {
            return this._arrowKeyBehavior;
        },
        set: function (val) {
            if (val !== 'move' && val !== 'select' && val !== 'scroll' && val !== 'none') {
                throw new Error("DrawCommandHandler.arrowKeyBehavior must be either \"move\", \"select\", \"scroll\", or \"none\", not: " + val);
            }
            this._arrowKeyBehavior = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DesignerCommandHandler.prototype, "pasteOffset", {
        /**
         * Gets or sets the offset at which each repeated pasteSelection() puts the new copied parts from the clipboard.
         * @name DrawCommandHandler#pasteOffset
         * @function.
         * @return {Point}
         */
        get: function () {
            return this._pasteOffset;
        },
        set: function (val) {
            if (!(val instanceof go.Point)) {
                throw new Error("DrawCommandHandler.pasteOffset must be a Point, not: " + val);
            }
            this._pasteOffset.set(val);
        },
        enumerable: true,
        configurable: true
    });
    // endregion
    // region layer
    /**
     * 获取选中的（非锁定）部分
     * @this {DrawCommandHandler}
     * @return array
     */
    DesignerCommandHandler.prototype.getSelectedParts = function () {
        var _this = this;
        var diagram = this.diagram;
        var selectedParts = new Array();
        diagram.selection.each(function (current) {
            if (!_this.canChangeZOrder(current)) {
                return;
            }
            selectedParts.push(current.data);
        });
        return selectedParts;
    };
    /**
     * 获取未选中的部分
     * @this {DrawCommandHandler}
     * @return array
     */
    DesignerCommandHandler.prototype.getUnselectedParts = function () {
        var diagram = this.diagram;
        var unselectedParts = new Array();
        var selectedParts = this.getSelectedParts();
        var nodeDataArray = diagram.model.nodeDataArray;
        var linkDataArray = diagram.model.linkDataArray;
        var dataArray = nodeDataArray.concat(linkDataArray);
        dataArray.forEach(function (data) {
            if (selectedParts.indexOf(data) === -1) {
                unselectedParts.push(data);
            }
        });
        return unselectedParts;
    };
    /**
     * 比选中的最大的还大的部分
     * @this {DrawCommandHandler}
     * @return array
     */
    DesignerCommandHandler.prototype.getLargerUnselectedParts = function () {
        var largerUnselectedParts = new Array();
        var unselectedParts = this.getUnselectedParts();
        var selectedMaxZOrder = this.layerService.getMaxZOrder(this.getSelectedParts());
        unselectedParts.forEach(function (data) {
            if (selectedMaxZOrder < data.zOrder) {
                largerUnselectedParts.push(data);
            }
        });
        return largerUnselectedParts;
    };
    /**
     * 获取未选中的，比选中的最小的还小的部分
     * @this {DrawCommandHandler}
     * @return array
     */
    DesignerCommandHandler.prototype.getSmallerUnselectedParts = function () {
        var smallerUnselectedParts = new Array();
        var unselectedParts = this.getUnselectedParts();
        var selectedMinZOrder = this.layerService.getMinZOrder(this.getSelectedParts());
        unselectedParts.forEach(function (data) {
            if (selectedMinZOrder > data.zOrder) {
                smallerUnselectedParts.push(data);
            }
        });
        return smallerUnselectedParts;
    };
    /**
     * 验证上一层及置顶
     * @this {DrawCommandHandler}
     */
    DesignerCommandHandler.prototype.validateFrontAndForward = function () {
        var _this = this;
        if (this.diagram.selection.filter(function (part) { return _this.canChangeZOrder(part); }).count < 1) {
            return false;
        }
        var selectedMinZOrder = this.layerService.getMinZOrder(this.getSelectedParts());
        var unselectedMaxZOrder = this.layerService.getMaxZOrder(this.getUnselectedParts());
        // 当同步旧数据是，所有ZOrder都为0
        var needShift = selectedMinZOrder !== 0 && unselectedMaxZOrder !== 0;
        if (needShift) {
            if (selectedMinZOrder >= unselectedMaxZOrder) {
                return false;
            }
        }
        return true;
    };
    /**
     * 验证下一层及置底
     * @this {DrawCommandHandler}
     */
    DesignerCommandHandler.prototype.validateBackAndBackward = function () {
        var _this = this;
        if (this.diagram.selection.filter(function (part) { return _this.canChangeZOrder(part); }).count < 1) {
            return false;
        }
        var selectedMaxZOrder = this.layerService.getMaxZOrder(this.getSelectedParts());
        var unselectedMinZOrder = this.layerService.getMinZOrder(this.getUnselectedParts());
        // 当同步旧数据是，所有ZOrder都为0
        var needShift = selectedMaxZOrder !== 0 && unselectedMinZOrder !== 0;
        if (needShift) {
            if (selectedMaxZOrder <= unselectedMinZOrder) {
                return false;
            }
        }
        return true;
    };
    /**
     * 置顶
     * @this {DrawCommandHandler}
     */
    DesignerCommandHandler.prototype.bringToFront = function () {
        var _this = this;
        if (!this.validateFrontAndForward()) {
            return;
        }
        this.diagram.startTransaction('bring To Front');
        var nodeDataArray = this.diagram.model.nodeDataArray;
        var linkDataArray = this.diagram.model.linkDataArray;
        var dataArray = nodeDataArray.concat(linkDataArray);
        var diagramSelection = _.orderBy(this.getSelectedParts(), 'zOrder');
        diagramSelection.forEach(function (part) {
            if (!part || part.locked) {
                return;
            }
            _this.setDataProperty(part, 'zOrder', _this.layerService.getMaxZOrder(dataArray) + 1);
        });
        this.diagram.commitTransaction('bring To Front');
    };
    /**
     * 置底
     * @this {DrawCommandHandler}
     */
    DesignerCommandHandler.prototype.sendToBack = function () {
        var _this = this;
        if (!this.validateBackAndBackward()) {
            return;
        }
        this.diagram.startTransaction('send To Back');
        var nodeDataArray = this.diagram.model.nodeDataArray;
        var linkDataArray = this.diagram.model.linkDataArray;
        var dataArray = nodeDataArray.concat(linkDataArray);
        var diagramSelection = _.orderBy(this.getSelectedParts(), 'zOrder').reverse();
        diagramSelection.forEach(function (part) {
            if (!part || part.locked) {
                return;
            }
            _this.setDataProperty(part, 'zOrder', _this.layerService.getMinZOrder(dataArray) - 1);
        });
        this.diagram.commitTransaction('send To Back');
    };
    /**
     * 上一层
     * @this {DrawCommandHandler}
     */
    DesignerCommandHandler.prototype.bringForward = function () {
        var _this = this;
        if (!this.validateFrontAndForward()) {
            return;
        }
        this.diagram.startTransaction('bring Forward');
        var forwardZOrder = this.layerService.getMinZOrder(this.getLargerUnselectedParts());
        var selectedMinZOrder = this.layerService.getMinZOrder(this.getSelectedParts());
        this.getUnselectedParts().forEach(function (part) {
            if (part.zOrder === forwardZOrder) {
                _this.setDataProperty(part, 'zOrder', selectedMinZOrder);
            }
        });
        this.diagram.selection.each(function (current) {
            if (!_this.canChangeZOrder(current)) {
                return;
            }
            _this.setDataProperty(current.data, 'zOrder', current.data.zOrder + 1);
        });
        this.diagram.commitTransaction('bring Forward');
    };
    /**
     * 下一层
     * @this {DrawCommandHandler}
     */
    DesignerCommandHandler.prototype.sendBackward = function () {
        var _this = this;
        if (!this.validateBackAndBackward()) {
            return;
        }
        this.diagram.startTransaction('send Backward');
        var backwardZOrder = this.layerService.getMaxZOrder(this.getSmallerUnselectedParts());
        var selectedMaxZOrder = this.layerService.getMaxZOrder(this.getSelectedParts());
        this.getUnselectedParts().forEach(function (part) {
            if (part.zOrder === backwardZOrder) {
                _this.setDataProperty(part, 'zOrder', selectedMaxZOrder);
            }
        });
        this.diagram.selection.each(function (current) {
            if (!_this.canChangeZOrder(current)) {
                return;
            }
            _this.setDataProperty(current.data, 'zOrder', current.data.zOrder - 1);
        });
        this.diagram.commitTransaction('send Backward');
    };
    DesignerCommandHandler.prototype.canChangeZOrder = function (current) {
        return current && current.data && !current.data.locked;
    };
    // endregion
    // region lock
    /**
     * lock element
     */
    DesignerCommandHandler.prototype.lock = function () {
        var _this = this;
        this.diagram.startTransaction('lock');
        this.diagram.selection.each(function (current) {
            if (!current.data || current instanceof go.Group) {
                return;
            } // skips over Groups
            _this.updateLockedInternal(current, true);
        });
        this.diagram.commitTransaction('lock');
    };
    /**
     * unlock element
     */
    DesignerCommandHandler.prototype.unlock = function () {
        var _this = this;
        this.diagram.startTransaction('unlock');
        this.diagram.selection.each(function (current) {
            if (!current.data || current instanceof go.Group) {
                return;
            } // skips over Groups
            _this.updateLockedInternal(current, false);
        });
        this.diagram.commitTransaction('unlock');
    };
    DesignerCommandHandler.prototype.updateLockedInternal = function (current, locked) {
        if (current.data && 'Text' !== current.data.category) {
            this.setDataProperty(current.data, 'locked', locked);
        }
        else {
            // TextElement is not resizable, so selectionAdornmentTemplate won't be updated
            current.resizable = true;
            this.setDataProperty(current.data, 'locked', locked);
            current.resizable = false;
        }
    };
    // endregion
    // region  SetwidthHight
    DesignerCommandHandler.prototype.sameHeight = function () {
        this.diagram.startTransaction('sameHeight');
        var parts = new Array();
        var sizeHelper = new ElementSizeHelper(this.diagram);
        this.diagram.selection.each(function (x) {
            if (!x.data.locked && x.data.category !== DiagramConsts.elements.weatherKey) {
                parts.push(x);
            }
        });
        if (parts.length < 2) {
            return;
        }
        var height = sizeHelper.getHeight(parts[0]);
        if (height < 0) {
            return;
        }
        for (var v = 1; v <= parts.length - 1; v++) {
            var part = parts[v];
            sizeHelper.setHeight(part, height);
        }
        this.diagram.commitTransaction('sameHeight');
    };
    DesignerCommandHandler.prototype.sameWidth = function () {
        this.diagram.startTransaction('sameWidth');
        var parts = new Array();
        var sizeHelper = new ElementSizeHelper(this.diagram);
        this.diagram.selection.each(function (x) {
            if (!x.data.locked && x.data.category !== DiagramConsts.elements.weatherKey) {
                parts.push(x);
            }
        });
        if (parts.length < 2) {
            return;
        }
        var width = sizeHelper.getWidth(parts[0]);
        if (width < 0) {
            return;
        }
        for (var v = 1; v <= parts.length - 1; v++) {
            var part = parts[v];
            sizeHelper.setWidth(part, width);
        }
        this.diagram.commitTransaction('sameWidth');
    };
    DesignerCommandHandler.prototype.sameSize = function () {
        this.diagram.startTransaction('sameSize');
        var parts = new Array();
        var sizeHelper = new ElementSizeHelper(this.diagram);
        this.diagram.selection.each(function (x) {
            if (!x.data.locked && x.data.category !== DiagramConsts.elements.weatherKey) {
                parts.push(x);
            }
        });
        if (parts.length < 2) {
            return;
        }
        var height = sizeHelper.getHeight(parts[0]);
        var width = sizeHelper.getWidth(parts[0]);
        if (height < 0 || width < 0) {
            return;
        }
        for (var v = 1; v <= parts.length - 1; v++) {
            var part = parts[v];
            sizeHelper.setSize(part, width, height);
        }
        this.diagram.commitTransaction('sameSize');
    };
    // endregion
    /**
     * change view zoom
     * @this {DrawCommandHandler}
     */
    DesignerCommandHandler.prototype.changeZoom = function (scale) {
        var diagram = this.diagram;
        if (diagram == null) {
            return;
        }
        var maxScale = diagram.maxScale;
        var minScale = diagram.minScale;
        if (scale > maxScale || scale < minScale) {
            return;
        }
        diagram.scale = scale;
    };
    DesignerCommandHandler.prototype.cxcommand = function (val) {
        var diagram = this.diagram;
        switch (val) {
            case 'addRow':
                this.addRow();
                break;
            case 'addCol':
                this.addColumn();
                break;
            case 'deleteRow':
                this.deleteRow();
                break;
            case 'deleteCol':
                this.deleteColumn();
                break;
        }
        diagram.currentTool.stopTool();
    };
    DesignerCommandHandler.prototype.findColumnDefinitionForColumn = function (nodedata, idx) {
        var columns = nodedata.columnDefinitions;
        for (var i = 0; i < columns.length; i++) {
            if (columns[i].column === idx) {
                return columns[i];
            }
        }
        return null;
    };
    DesignerCommandHandler.prototype.addColumn = function () {
        var _this = this;
        this.diagram.startTransaction('addColumn');
        this.diagram.rebuildParts();
        this.diagram.selection.each(function (current) {
            if (current === null || current.category !== 'Table') {
                return;
            }
            var d = current.data;
            var model = _this.diagram.model;
            var items = _.cloneDeep(d.items);
            var widths = _.cloneDeep(current.data.widths);
            if (items[0].columns.length > 9) {
                return;
            }
            for (var j = 0; j < items.length; j++) {
                var item = items[j];
                model.addArrayItem(item.columns, {
                    column: item.columns.length,
                    text: ''
                });
            }
            if (!widths[widths.length - 1]) {
                widths.pop();
            }
            var lastColumnWidth = widths[widths.length - 1];
            model.addArrayItem(widths, lastColumnWidth);
            // 分割线宽度也要计算在内  1
            current.desiredSize.width += lastColumnWidth + 1;
            new ColumnResizingTool().updateAdornments(current, true);
            _this.setDataProperty(current.data, 'widths', widths);
            _this.setDataProperty(current.data, 'items', items);
            _this.setDataProperty(current.data, 'size', new Size(current.desiredSize.width, current.desiredSize.height).toString());
        });
        this.diagram.rebuildParts();
        this.diagram.commitTransaction('addColumn');
    };
    DesignerCommandHandler.prototype.addRow = function () {
        var _this = this;
        this.diagram.startTransaction('addRow');
        this.diagram.rebuildParts();
        this.diagram.selection.each(function (current) {
            if (current === null || current.category !== 'Table') {
                return;
            }
            var d = current.data;
            var model = _this.diagram.model;
            var items = _.cloneDeep(d.items);
            var heights = _.cloneDeep(current.data.heights);
            if (items.length > 9) {
                return;
            }
            var columns = _.cloneDeep(items[0]);
            model.addArrayItem(items, columns);
            if (!heights[heights.length - 1]) {
                heights.pop();
            }
            var lastRowHeight = heights[heights.length - 1];
            model.addArrayItem(heights, lastRowHeight);
            // 分割线宽度也要计算在内  1
            current.desiredSize.height += lastRowHeight + 1;
            new RowResizingTool().updateAdornments(current, true);
            _this.setDataProperty(current.data, 'heights', heights);
            _this.setDataProperty(current.data, 'items', items);
            _this.setDataProperty(current.data, 'size', new Size(current.desiredSize.width, current.desiredSize.height).toString());
        });
        this.diagram.rebuildParts();
        this.diagram.commitTransaction('addRow');
    };
    DesignerCommandHandler.prototype.deleteRow = function () {
        var _this = this;
        this.diagram.startTransaction('deleteRow');
        this.diagram.rebuildParts();
        this.diagram.selection.each(function (current) {
            if (current === null || current.category !== 'Table') {
                return;
            }
            var d = current.data;
            var rows = d.items.length;
            if (rows <= 2) {
                return;
            }
            var items = _.cloneDeep(d.items);
            var model = _this.diagram.model;
            var heights = _.cloneDeep(current.data.heights);
            model.removeArrayItem(items, items.length - 1);
            if (!heights[heights.length - 1]) {
                heights.pop();
            }
            current.desiredSize.height -= heights[heights.length - 1];
            model.removeArrayItem(heights, heights.length - 1);
            new RowResizingTool().updateAdornments(current, true);
            _this.setDataProperty(current.data, 'items', items);
            _this.setDataProperty(current.data, 'heights', heights);
            _this.setDataProperty(current.data, 'size', new Size(current.desiredSize.width, current.desiredSize.height - 1).toString());
        });
        this.diagram.rebuildParts();
        this.diagram.commitTransaction('deleteRow');
    };
    DesignerCommandHandler.prototype.deleteColumn = function () {
        var _this = this;
        this.diagram.startTransaction('deleteColumn');
        this.diagram.rebuildParts();
        this.diagram.selection.each(function (current) {
            if (current === null || current.category !== 'Table') {
                return;
            }
            var d = current.data;
            var columns = d.items[0].columns.length;
            if (columns <= 2) {
                return;
            }
            var items = _.cloneDeep(d.items);
            var model = _this.diagram.model;
            var widths = _.cloneDeep(current.data.widths);
            for (var j = 0; j < items.length; j++) {
                var item = items[j];
                model.removeArrayItem(item.columns, item.columns.length - 1);
            }
            if (!widths[widths.length - 1]) {
                widths.pop();
            }
            current.desiredSize.width -= widths[widths.length - 1];
            model.removeArrayItem(widths, widths.length - 1);
            new ColumnResizingTool().updateAdornments(current, true);
            _this.setDataProperty(current.data, 'items', items);
            _this.setDataProperty(current.data, 'widths', widths);
            _this.setDataProperty(current.data, 'size', new Size(current.desiredSize.width - 1, current.desiredSize.height).toString());
        });
        this.diagram.rebuildParts();
        this.diagram.commitTransaction('deleteColumn');
    };
    return DesignerCommandHandler;
}(go.CommandHandler));
export { DesignerCommandHandler };
